var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

import EventRunnerAbstract from "./EventRunnerAbstract";

var EventRunnerDefault = function (_super) {
  __extends(EventRunnerDefault, _super);

  function EventRunnerDefault() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  EventRunnerDefault.prototype.run = function (eventName) {
    var args = [];

    for (var _i = 1; _i < arguments.length; _i++) {
      args[_i - 1] = arguments[_i];
    }

    this.handler.apply(null, args);
  };

  return EventRunnerDefault;
}(EventRunnerAbstract);

export default EventRunnerDefault;